export default {
    app: {
        name:              'NMR portal',
        institution:       'Kemijski inštitut',
        version:           'Različica 1.0.0',
        about:             'O sistemu',
        label_name:        'Aplikacija',
        label_institution: 'Ustanova',
        label_version:     'Različica',
    },
    general: {
        add:          'Dodaj',
        edit:         'Uredi',
        cancel:       'Prekliči',
        save:         'Shrani',
        delete:       'Izbriši',
        close:        'Zapri',
        confirm:      'Potrdi',
        back:         'Nazaj',
        next:         'Naprej',
        search:       'Iskanje',
        search_hint:  'Išči …',
        actions:      'Dejanja',
        yes:          'Da',
        no:           'Ne',
        all:          'Vse',
        none:         'Brez',
        loading:      'Nalaganje …',
        name:         'Naziv',
        email:        'E-naslov',
        phone:        'Telefon',
        password:     'Geslo',
        color:        'Barva',
        description:  'Opis',
        status:       'Status',
        today:        'Danes',
        from:         'Od',
        to:           'Do',
        date:         'Datum',
        time:         'Čas',
        of:           'od',
        more:         'več',
        info:         'Informacije',
        details:      'Podrobnosti',
        remove:       'Odstrani',
        select:       'Izberi',
        optional:     'neobvezno',
        no_data:      'Ni podatkov',
        access_denied: 'Dostop zavrnjen',
        access_denied_desc: 'Nimate pravic za ogled te strani.',
        not_found:    'Stran ni najdena',
        not_found_desc: 'Iskane strani ni bilo mogoče najti.',
        go_home:      'Nazaj na nadzorno ploščo',
        light:        'Svetla tema',
        dark:         'Temna tema',
    },
    nav: {
        management:   'Upravljanje',
        personal:     'Osebno',
        dashboard:    'Nadzorna plošča',
        reservations: 'Rezervacije',
        devices:      'Naprave',
        probes:       'Sonde',
        users:        'Uporabniki',
        groups:       'Skupine',
        clients:      'Stranke',
        quotas:       'Kvote',
        reports:      'Poročila',
        downtimes:    'Nedelovanja',
        confirmations: 'Potrditve',
        probe_plan:   'Menjave sond',
        notifications: 'Obvestila',
        settings:     'Nastavitve',
        profile:      'Profil',
    },
    errors: {
        generic_error:      'Prišlo je do napake',
        invalid_data:       'Neveljavni podatki',
        not_found:          'Ni najdeno',
        unauthorized:       'Neavtoriziran dostop',
        forbidden:          'Nimate pravic za to dejanje',
        internal:           'Napaka na strežniku',
        failed_to_insert:   'Vnos ni uspel',
        slot_occupied:      'Termin je že zaseden. Izberite drug termin.',
        quota_exceeded:     'Skupina nima dovolj kvot za to napravo v tem obdobju.',
        email_in_use:       'E-naslov je že v uporabi.',
        has_reservations:   'Brisanje ni mogoče: obstajajo prihajajoče rezervacije.',
        already_resolved:   'Zahtevek je že obravnavan.',
        wrong_old_password: 'Staro geslo ni pravilno.',
        in_use:             'Brisanje ni mogoče: element je v uporabi.',
        on_add:             'Napaka pri dodajanju',
        on_edit:            'Napaka pri posodabljanju',
        on_delete:          'Napaka pri brisanju',
        login_failed:       'Napačen e-naslov ali geslo',
    },
    success: {
        add:       'Uspešno dodano',
        edit:      'Uspešno posodobljeno',
        delete:    'Uspešno izbrisano',
        saved:     'Uspešno shranjeno',
    },
    validation: {
        required:      'To polje je obvezno',
        time_order:    'Konec mora biti po začetku',
        email:         'Neveljaven e-naslov',
        min_password:  'Geslo mora imeti vsaj 6 znakov',
        password_match: 'Gesli se ne ujemata',
        min1:          'Vrednost mora biti vsaj 1',
        max_length:    'Največ {n} znakov',
    },
    login: {
        demo_user_plain: 'Uporabnik (brez poročil)',
        demo_user_reports: 'Uporabnik (s poročili)',
        title:       'Prijava',
        subtitle:    'Prijavite se v NMR portal',
        remember:    'Zapomni si me',
        forgot:      'Pozabljeno geslo?',
        submit:      'Prijava',
        demo:        'Hitra prijava (demo)',
        forgot_stub: 'Za ponastavitev gesla se obrnite na skrbnika sistema.',
    },
    role: {
        reporter: 'Analitik',
        super_admin: 'Super administrator',
        probe_admin: 'Administrator sond',
        user:        'Uporabnik',
    },
    dashboard: {
        greeting_morning:   'Dobro jutro',
        greeting_day:       'Dober dan',
        greeting_evening:   'Dober večer',
        new_reservation:    'Nova rezervacija',
        my_upcoming:        'Moje prihajajoče rezervacije',
        this_week:          'Ta teden',
        pending:            'Čaka na potrditev',
        upcoming:           'Prihajajoče rezervacije',
        no_upcoming:        'Ni prihajajočih rezervacij',
        recent:             'Pretekle rezervacije',
        recent_hint:        'Prikazane so rezervacije, ki jih lahko še urejate ({n} dni po koncu)',
        no_recent_editable: 'Ni preteklih rezervacij, ki bi jih lahko še urejali (rok: {n} dni po koncu).',
        older:              'Starejše rezervacije',
        no_older:           'Ni starejših rezervacij',
        show_older:         'Prikaži starejše rezervacije',
        load_more:          'Naloži več',
        hide_older:         'Skrij starejše',
        pending_user:       'Čaka na potrditev s strani administratorja',
        quota_used_short:   'porabljeno',
        quota_free_of:      'prostih od {n}',
        quota_free_short:   '{free} prostih / {allocated}',
        quota_used_n:       '{n} porabljenih',
        quota_reserved_n:   '{n} rezerviranih',
        quota_period:       'Obdobje {from} – {to} · obnova {renews} ({renewal})',
        quota_period_short: '{renewal}: {from} – {to} (obnova {renews})',
        quota_no_renewal:   'Kvota se ne obnavlja',
        quota_explain:      'Kvota se odšteje že ob rezervaciji (»rezervirano«); ko termin mine, šteje kot »porabljeno«. Preklicana rezervacija kvoto vrne. Ob obnovi se kvote spet napolnijo.',
        my_quotas:          'Moje kvote',
        no_quotas:          'Ni dodeljenih kvot',
        active_devices:     'Aktivne naprave',
        week_reservations:  'Rezervacije ta teden',
        users:              'Uporabniki',
        groups:             'skupin',
        device_utilization: 'Zasedenost naprav',
        device_utilization_hint: 'Rezervirane ure ta teden ({from} – {to})',
        device_utilization_week: 'Rezervirane ure v tednu {from} – {to}',
        week_prev:          'Prejšnji teden',
        week_next:          'Naslednji teden',
        reservations_n:     '{n} rez.',
        probe_changes:      'Naslednje menjave sond',
        probe_changes_all:  'Vse menjave',
    },
    reservation: {
        title:            'Rezervacije',
        subtitle_user:    'Vaše rezervacije NMR naprav',
        subtitle_admin:   'Vse rezervacije v sistemu',
        tab_list:         'Seznam',
        tab_calendar:     'Koledar',
        filter_device:    'Naprava',
        filter_group:     'Skupina',
        filter_status:    'Status',
        all_devices:      'Vse naprave',
        all_groups:       'Vse skupine',
        all_statuses:     'Vsi statusi',
        col_date:         'Datum',
        col_time:         'Čas',
        col_operator:     'Operater',
        col_group:        'Skupina',
        col_device:       'Naprava',
        col_project:      'Projekt',
        col_probe:        'Želena sonda',
        col_status:       'Status',
        col_note:         'Opombe',
        detail_title:     'Podrobnosti rezervacije',
        cancel_reservation: 'Prekliči termin',
        confirm_cancel:   'Ali res želite preklicati ta termin?',
        cancel_title:     'Odpoved termina',
        cancel_reason:    'Razlog odpovedi',
        cancel_reason_placeholder: 'Neobvezno — razlog bo vključen v obvestilo uporabniku.',
        cancelled_toast:  'Termin preklican',
        edit_title:       'Uredi rezervacijo',
        edit_reservation: 'Uredi rezervacijo',
        saved_toast:      'Rezervacija posodobljena',
        span_hint:        'Rezervacija sega čez več dni — noči med dnevi so brezplačne.',
        start_time:       'Začetek',
        end_time:         'Konec',
        note:             'Opombe',
        note_placeholder: 'Neobvezna opomba k terminu …',
        feedback:         'Pošlji povratno informacijo',
        feedback_title:   'Povratna informacija o terminu',
        feedback_intro:   'Sporočite administratorjem morebitne težave pri delu s spektrometrom v tem terminu.',
        feedback_message: 'Sporočilo',
        feedback_placeholder: 'Opišite težavo ali opažanje …',
        feedback_sent:    'Povratna informacija poslana',
        feedback_sent_mark: 'Povratna informacija poslana',
        operator:         'Operater',
        current_probe:    'Trenutna sonda',
        no_reservations:  'Ni rezervacij',
        view_day:         'Dan',
        view_week:        'Teden',
        view_month:       'Mesec',
        column_devices:   'Naprave',
        column_groups:    'Skupine',
        column_view:      'Pogled',
        legend_confirmed: 'Potrjeno',
        legend_pending:   'Čaka na potrditev (črtkano)',
        legend_overnight: 'Nočni termin (naprava zasedena do jutra)',
        cal_overnight_until: 'noč do {time}',
        cal_continued_from:  'od {time}',
        cal_continues_until: 'do {time}',
        cal_until_short:     'do {time}',
        past_edit_title:  'Rezervacija je že potekla',
        past_edit_notice: 'Čas, naprave in sonde ni več mogoče spremeniti. Skupino, projekt in opombo lahko popravite do {deadline}.',
        legend_now:       'Trenutni čas',
        legend_mine:      'Moje rezervacije',
        legend_others:    'Drugi uporabniki',
        legend_devices:   'Barva = naprava',
        status: {
            confirmed: 'Potrjeno',
            pending:   'Čaka na potrditev',
            cancelled: 'Preklicano',
        },
    },
    wizard: {
        no_groups_title: 'Niste član nobene skupine',
        no_groups_desc: 'Vsaka rezervacija mora biti vezana na raziskovalno skupino. Za dodelitev skupine se obrnite na administratorja.',
        title:            'Nova rezervacija',
        step_data:        'Podatki',
        step_slot:        'Termin',
        step_probe:       'Sonda',
        step_review:      'Pregled',
        operator:         'Operater',
        group:            'Raziskovalna skupina',
        group_placeholder: 'Izberite skupino',
        project:          'Projekt / stranka',
        project_placeholder: 'Interno (brez projekta)',
        project_manual:   'Vnesi ročno …',
        project_custom:   'Naziv projekta / stranke',
        project_custom_placeholder: 'Npr. Projekt ARRS J1-1234',
        note:             'Opombe',
        note_placeholder: 'Neobvezna opomba k terminu …',
        device:           'Naprava',
        device_interval:  'Interval: {min} min',
        select_date:      'Izberite datum',
        slot_help:        'Kliknite začetni termin, nato kliknite končni termin za izbiro obsega zaporednih prostih terminov.',
        last_free:        'Zadnji prost termin',
        quota_available:  'Skupina ima za napravo {device} na voljo {remaining} od {allocated} kvot (obnova {renewal})',
        quota_none:       'Za to skupino in napravo ni dodeljenih kvot.',
        quota_window:     'Za izbrani datum velja obdobje {period}.',
        quota_over:       'Izbrani termin presega razpoložljivo kvoto skupine za to obdobje. Skrajšajte termin ali izberite drug datum.',
        slot_uses:        'Ta termin porabi {n} kvot',
        slot_uses_partial: 'Najmanj {n} kvot (delni izračun)',
        legend_quota:     'Šteje v kvoto',
        multi_day:        'Večdnevna rezervacija',
        multi_day_hint:   'Izberite začetni dan in termin na levi ter končni dan in termin na desni. Noči med dnevi so brezplačne.',
        start_day:        'Začetni dan',
        end_day:          'Končni dan',
        span_conflict:    'V izbranem obdobju so zasedeni ali zaprti termini — izberite drugo obdobje.',
        span_preview_limited: 'Obdobje je daljše od {days} dni — porabe kvot ni mogoče izračunati vnaprej, preveril jo bo strežnik.',
        overnight_title:  'Nočni termin',
        overnight_short:  'do {time}',
        overnight_notice: 'Zadnji termin dneva je nočni termin — kdor ga rezervira, lahko napravo uporablja do naslednjega dne do {time}.',
        legend_free:      'Izven kvote',
        window_notice:    'Izbrani datum je zunaj obdobja prostega rezerviranja za to napravo ({days} dni), zato bo rezervacija čakala na potrditev administratorja. Ko datum vstopi v obdobje, se potrdi samodejno.',
        recurrence:       'Ponavljanje termina',
        frequency:        'Pogostost',
        occurrences:      'Število ponovitev',
        effective_probe:  'Ob izbranem terminu bo nameščena: {probe}',
        effective_none:   'Na napravi ob terminu ni določene sonde.',
        probe_effective_badge: 'trenutna ob terminu',
        probe_pending_notice: 'Ker izbrana sonda ni nameščena ob terminu, bo rezervacija v čakanju, dokler je administrator ne potrdi.',
        no_compatible_probes: 'Za to napravo ni kompatibilnih sond.',
        needs_confirm:    'potrebna potrditev',
        review_intro:     'Preverite podatke pred potrditvijo.',
        submit:           'Potrdi rezervacijo',
        created_one:      'Vaša rezervacija je bila potrjena.',
        created_many:     'Ustvarili ste {n} rezervacij.',
        created_pending:  'Rezervacija ustvarjena in čaka na potrditev administratorja.',
        no_slots:         'Za izbrani dan ni terminov.',
        slot_reason: {
            closed:   'Zaprto',
            occupied: 'Zasedeno',
            downtime: 'Nedelovanje',
            quota:    'Ni dovolj kvot',
        },
        freq: {
            daily:   'Dnevno',
            weekly:  'Tedensko',
            monthly: 'Mesečno',
        },
        no_recurrence: 'Brez ponavljanja',
    },
    device: {
        closed_all_day: 'Zaprto ves dan',
        schedule_same: 'Enak urnik za vse dni',
        schedule_same_desc: 'Isti delovni čas in kvote vsak dan',
        schedule_per_day: 'Urnik po dnevih',
        schedule_per_day_desc: 'Ločen urnik in kvote za vsak dan v tednu',
        per_day_hint: 'Vsak dan ima svoj delovni čas in kvote. Prazen dan pomeni, da je naprava ta dan zaprta. Sistemsko pravilo »vikend ne šteje v kvoto« za to napravo ne velja – veljajo kvote, nastavljene za soboto in nedeljo.',
        day_closed_all: 'Ta dan je naprava zaprta ves dan – dodajte pas, če želite omogočiti rezervacije.',
        copy_to_weekdays: 'Kopiraj na delavnike',
        copy_to_weekend: 'Kopiraj na vikend',
        copy_to_all: 'Kopiraj na vse dni',
        close_day: 'Zapri ves dan',
        closed_short: 'zaprto',
        schedule_label: 'Urnik',
        title:          'Naprave',
        subtitle:       'Upravljanje NMR naprav',
        col_name:       'Ime naprave',
        col_status:     'Status',
        col_color:      'Barva',
        col_interval:   'Interval',
        col_probe:      'Trenutna sonda',
        col_reservations: 'Rezervacije',
        info:           'Informacije',
        set_probe:      'Trenutna sonda',
        downtime:       'Nedelovanje',
        interval_min:   '{min} min',
        slot_length:    'Dolžina termina',
        free_window:    'Okno prostih rezervacij (dni)',
        free_window_help: '0 = brez omejitve. Rezervacije uporabnikov, ki se začnejo pozneje kot toliko dni od danes, čakajo na potrditev administratorja.',
        free_window_unlimited: 'Brez omejitve',
        compatible_probes: 'Kompatibilne sonde',
        hour_bands:     'Delovni čas in kvote po urah',
        band_from:      'Od',
        band_to:        'Do',
        band_open:      'Odprto',
        band_closed:    'Zaprto',
        band_cost:      'Št. kvot',
        band_order_error: 'Konec pasu mora biti za začetkom.',
        band_overlap_error: 'Pasova {a} in {b} se prekrivata — popravite čase.',
        add_band:       'Dodaj pas',
        free:           'Brezplačno',
        info_title:     'Informacije o napravi',
        set_probe_title: 'Nastavi trenutno sondo',
        add_device:     'Nova naprava',
        edit_device:    'Uredi napravo',
        delete_confirm: 'Ali res želite izbrisati to napravo?',
        no_devices:     'Ni naprav',
        status: {
            active:   'Aktivna',
            inactive: 'Neaktivna',
        },
    },
    downtime: {
        title:          'Nedelovanja',
        subtitle:       'Načrtovana nedelovanja naprav',
        add:            'Dodaj nedelovanje',
        device:         'Naprava',
        period:         'Obdobje',
        pick_period:    'Izberi obdobje',
        time_from:      'Od (ura)',
        time_to:        'Do (ura)',
        reason:         'Razlog',
        filter_device:  'Naprava',
        tab_upcoming:   'Prihajajoča',
        tab_history:    'Zgodovina',
        empty_upcoming: 'Ni prihajajočih nedelovanj',
        empty_history:  'Ni zabeleženih nedelovanj',
        delete_confirm: 'Ali res želite izbrisati to nedelovanje?',
    },
    probe: {
        title:       'Sonde',
        subtitle:    'Katalog NMR sond',
        col_name:    'Naziv',
        col_code:    'Oznaka',
        col_type:    'Tip',
        add_probe:   'Nova sonda',
        edit_probe:  'Uredi sondo',
        delete_confirm: 'Ali res želite izbrisati to sondo?',
        no_probes:   'Ni sond',
    },
    probe_type: {
        title:          'Tipi sond',
        add:            'Nov tip sonde',
        edit:           'Uredi tip sonde',
        empty:          'Ni tipov sond',
        delete_confirm: 'Ali res želite izbrisati ta tip sonde?',
    },
    user: {
        reporter_hint: 'Analitik vidi in izvaža poročila vseh uporabnikov, ne more pa rezervirati ali urejati.',
        title:        'Uporabniki',
        subtitle:     'Upravljanje uporabnikov',
        col_user:     'Uporabnik',
        col_contact:  'Kontakt',
        col_role:     'Vloga',
        col_groups:   'Skupine',
        col_status:   'Status',
        role:         'Vloga',
        groups:       'Skupine',
        groups_hint:  'Uporabnik je lahko član več skupin.',
        password_edit: 'pustite prazno za nespremenjeno',
        active:       'Aktiven',
        can_view_reports: 'Dostop do poročil',
        can_view_reports_desc: 'Uporabnik lahko pregleduje poročila o porabi in evidenco izvedenih rezervacij (vsi administratorji ga imajo samodejno).',
        active_label: 'Aktiven',
        inactive_label: 'Onemogočen',
        add_user:     'Nov uporabnik',
        edit_user:    'Uredi uporabnika',
        delete_confirm: 'Ali res želite izbrisati tega uporabnika?',
        no_users:     'Ni uporabnikov',
        first_name:   'Ime',
        last_name:    'Priimek',
    },
    group: {
        title:        'Skupine',
        subtitle:     'Raziskovalne skupine',
        leader:       'Vodja',
        members:      'Člani',
        member_count: '{n} članov',
        quotas:       'Kvote',
        members_title: 'Člani skupine',
        add_member:   'Dodaj člana',
        member_select: 'Izberite uporabnika',
        quotas_title: 'Kvote skupine',
        allocated:    'Dodeljeno kvot',
        renewal:      'Obnavljanje',
        add_group:    'Nova skupina',
        edit_group:   'Uredi skupino',
        delete_confirm: 'Ali res želite izbrisati to skupino?',
        no_groups:    'Ni skupin',
        no_members:   'Skupina nima članov',
    },
    client: {
        title:       'Stranke in projekti',
        subtitle:    'Upravljanje strank in projektov',
        tab_clients: 'Stranke',
        tab_projects: 'Projekti',
        col_name:    'Naziv',
        col_type:    'Tip',
        col_contact: 'Kontakt',
        contact:     'Kontakt',
        show_archived: 'Prikaži arhivirane',
        archived:    'Arhivirano',
        archived_hint: 'Arhivirana stranka se ne ponuja več pri izbiri.',
        archive:     'Arhiviraj',
        unarchive:   'Povrni iz arhiva',
        archived_toast:   'Arhivirano',
        unarchived_toast: 'Povrnjeno iz arhiva',
        add_client:  'Nova stranka',
        edit_client: 'Uredi stranko',
        delete_confirm: 'Ali res želite izbrisati to stranko?',
        no_clients:  'Ni strank',
        type: {
            internal: 'Interna',
            external: 'Zunanja',
        },
    },
    project: {
        col_name:    'Naziv',
        col_code:    'Oznaka',
        code:        'Oznaka',
        client:      'Stranka',
        no_client:   'Interno (brez stranke)',
        groups:      'Skupine',
        groups_all:  'Vse skupine',
        groups_help: 'Pustite prazno, če je projekt na voljo vsem skupinam.',
        groups_all_hint: 'Ni izbrane nobene skupine — projekt je na voljo vsem skupinam.',
        archived_hint: 'Arhiviran projekt se ne ponuja več pri rezervacijah.',
        add_project: 'Nov projekt',
        edit_project: 'Uredi projekt',
        delete_confirm: 'Ali res želite izbrisati ta projekt?',
        no_projects: 'Ni projektov',
    },
    quota: {
        title:        'Kvote',
        subtitle:     'Pregled porabe kvot',
        edit_note:    'Kvote se urejajo pri Skupine → Kvote.',
        used:         'Porabljeno',
        reserved:     'V rezervacijah',
        free:         'Prosto',
        allocated:    'Dodeljeno',
        percent_used: '{pct}% porabljeno',
        renewal_label: 'Obnova: {renewal}',
        filter_group: 'Skupina',
        filter_device: 'Naprava',
        period:          'Obdobje',
        period_current:  'Trenutno obdobje',
        period_month:    'Ta mesec',
        period_3m:       'Zadnji 3 meseci',
        period_6m:       'Zadnjih 6 mesecev',
        period_year:     'Zadnje leto',
        consumption:  'Poraba {used}/{allocated} ({pct}%)',
        no_allocations: 'Ni dodeljenih kvot',
        no_group_allocations: 'Za to napravo ni dodeljenih kvot skupinam.',
        renewal: {
            weekly:  'Tedensko',
            monthly: 'Mesečno',
            yearly:  'Letno',
            never:   'Brez obnavljanja',
        },
    },
    report: {
        tab_overview: 'Pregled',
        tab_devices: 'Po napravah',
        tab_clients: 'Po strankah in projektih',
        tab_groups: 'Po skupinah',
        tab_details: 'Podrobne rezervacije',
        clients_hint: 'Poraba vseh naprav po strankah – kliknite vrstico za projekte',
        groups_hint: 'Poraba vseh naprav po raziskovalnih skupinah – kliknite vrstico za uporabnike',
        col_projects: 'Projekti',
        col_users: 'Uporabniki',
        col_by_device: 'Po napravah',
        no_project: 'Brez projekta',
        free_text: 'ročni vnos',
        chart_hover_hint: 'Premaknite miško nad stolpec za podrobnosti',
        col_share: 'Delež',
        col_count_short: 'Rez.',
        kpi_hours: 'Rezervirane ure',
        kpi_reservations: 'Rezervacije',
        kpi_occupancy: 'Zasedenost',
        kpi_occupancy_sub: '{booked} od {open} odprtih ur',
        kpi_users: 'Uporabniki',
        kpi_groups: '{n} skupin',
        kpi_devices: 'Uporabljene naprave',
        kpi_devices_sub: 'z vsaj eno rezervacijo',
        summary_title: 'Povzetek obdobja',
        devices_compare: 'Primerjava naprav',
        occupancy_short: '{pct} % zasedenost',
        subtitle_own: 'Poraba vaših rezervacij po obdobju in naročnikih',
        export_summary: 'Izvozi povzetek (CSV)',
        export_reservations: 'Izvozi rezervacije (CSV)',
        csv_device: 'Naprava',
        csv_kind: 'Vrsta',
        csv_name: 'Naziv',
        csv_hours: 'Ure',
        csv_count: 'Št. rezervacij',
        csv_total: 'Skupaj',
        csv_start: 'Začetek',
        csv_end: 'Konec',
        title:          'Poročila',
        subtitle:       'Poraba naprav po obdobju in naročnikih',
        filter_device:  'Naprava',
        period:         'Obdobje',
        pick_period:    'Izberi obdobje',
        preset_this_week:  'Ta teden',
        preset_this_month: 'Ta mesec',
        preset_last_month: 'Prejšnji mesec',
        preset_this_year:  'Letos',
        total_hours:    'Skupaj ur',
        total_reservations: 'Št. rezervacij',
        by_day:         'Zasedenost po dnevih',
        by_day_hint:    'Rezervirane ure na dan · klik na dan odpre podrobne rezervacije tega dne',
        day_bucket:     '{day}: {hours}',
        by_group:       'Po skupinah',
        col_group:      'Skupina',
        no_group:       'Brez skupine',
        by_client:      'Po naročnikih',
        col_client:     'Naročnik',
        col_hours:      'Ure',
        col_count:      'Št. rezervacij',
        no_client:      'Brez naročnika',
        no_usage:       'V tem obdobju ni porabe.',
        empty:          'Za izbrano obdobje ni podatkov',
        detail_title:   'Podrobne rezervacije',
        detail_empty:   'V izbranem obdobju ni rezervacij',
        detail_day:     'Dan',
        detail_all_days: 'Vsi dnevi obdobja',
        detail_all_users: 'Vsi uporabniki',
        detail_clear:   'Počisti filtre',
        detail_count:   'Prikazanih {n} od {total}',
        hours_short:        '{h} h',
        minutes_short:      '{m} min',
        hours_minutes_short: '{h} h {m} min',
    },
    notification: {
        title:         'Obvestila',
        subtitle_zero: 'Nimate neprebranih obvestil',
        subtitle_some: 'Imate {n} neprebranih obvestil',
        mark_all_read: 'Označi vse kot prebrano',
        mark_unread:   'Označi kot neprebrano',
        delete:        'Izbriši',
        delete_read:   'Izbriši prebrana',
        delete_read_confirm: 'Izbrišem {n} prebranih obvestil? Tega ni mogoče razveljaviti.',
        deleted_read_toast: 'Prebrana obvestila so izbrisana',
        unread_only:   'Samo neprebrana',
        no_filtered:   'Ni obvestil za izbrani filter',
        category: {
            all:          'Vsa',
            reservation:  'Rezervacije',
            probe_change: 'Menjave sond',
            feedback:     'Povratne informacije',
            message:      'Sporočila',
        },
        reply:         'Odgovori',
        reply_message: 'Vaš odgovor',
        reply_placeholder: 'Napišite odgovor …',
        reply_send:    'Pošlji odgovor',
        reply_sent:    'Odgovor poslan',
        reply_to_person: 'Prejme: {name}',
        reply_to_admins: 'Prejmejo: skrbniki',
        compose:       'Novo obvestilo',
        tab_inbox:     'Prejeto',
        tab_sent:      'Poslano',
        highlighted:   'Izpostavljeno',
        sender:        'Pošiljatelj',
        target:        'Prejemniki',
        sent_to:       'za: {target}',
        no_inbox:      'Ni obvestil',
        no_sent:       'Ni poslanih obvestil',
        compose_title: 'Novo obvestilo',
        field_title:   'Naslov',
        field_message: 'Sporočilo',
        field_type:    'Vrsta',
        field_recipients: 'Prejemniki',
        field_highlighted: 'Izpostavljeno obvestilo',
        recipient_all:    'Vsi uporabniki',
        recipient_groups: 'Izbrane skupine',
        recipient_person: 'Določena oseba',
        select_groups: 'Izberite skupine',
        select_person: 'Izberite osebo',
        sent_toast:    'Obvestilo poslano ({n} prejemnikov)',
        type: {
            info:    'Informacija',
            success: 'Uspeh',
            warning: 'Opozorilo',
            error:   'Napaka',
            request: 'Zahtevek',
        },
    },
    confirmation: {
        title:          'Potrditve',
        subtitle:       'Rezervacije, ki čakajo na potrditev administratorja',
        empty_title:    'Ni čakajočih potrditev',
        empty_desc:     'Vse rezervacije so potrjene.',
        swap_badge:     'menjava',
        reasons:        'Razlogi',
        reason: {
            probe_mismatch: 'Menjava sonde',
            outside_window: 'Izven okna',
        },
        previous:       'Prejšnja rezervacija',
        next:           'Naslednja rezervacija',
        no_probe:       'Brez sonde',
        confirm:        'Potrdi',
        reject:         'Zavrni',
        reject_title:   'Zavrni rezervacijo',
        reject_confirm: 'Ali res želite zavrniti to rezervacijo? Uporabnik bo obveščen.',
        reject_reason:  'Razlog zavrnitve',
        reject_reason_placeholder: 'Neobvezno — razlog bo vključen v obvestilo uporabniku.',
        confirmed_toast: 'Rezervacija potrjena',
        rejected_toast: 'Rezervacija zavrnjena',
    },
    probe_plan: {
        title:          'Menjave sond',
        subtitle:       'Načrt menjav sond, izpeljan iz potrjenih rezervacij',
        filter_device:  'Naprava',
        filter_probe:   'Sonda',
        all_probes:     'Vse sonde',
        swap:           'Menjava',
        empty:          'Ni načrtovanih menjav sond',
        ready_at:       'Prosto od',
        due_at:         'Potrebno do',
        needed_by:      'Potrebuje',
        complete:       'Potrdi menjavo',
        complete_confirm: 'Potrjujete, da je sonda {probe} fizično nameščena na napravo {device}? S tem se nastavi kot aktivna sonda naprave.',
        completed_toast: 'Menjava sonde potrjena',
        completed_by:   'Opravljeno: {name}, {at}',
        backlog_hint:   'Prejšnje rezervacije še potrebujejo trenutno sondo.',
        period_upcoming: 'Prihajajoče',
        status: {
            backlog: 'V pripravi',
            todo:    'Za opraviti',
            overdue: 'Zamuja',
            done:    'Opravljeno',
        },
    },
    settings: {
        title:        'Nastavitve',
        subtitle:     'Nastavitve obvestil',
        email_notifications: 'E-poštna obvestila',
        email_desc:   'Prejemajte obvestila po elektronski pošti.',
        system_title:    'Sistemske nastavitve',
        system_subtitle: 'Veljajo za vse uporabnike',
        edit_window:     'Urejanje preteklih rezervacij',
        edit_window_desc: 'Koliko dni po koncu rezervacije lahko uporabnik še popravi njeno skupino, projekt in opombo. 0 = ni mogoče.',
        weekend_free:    'Sobotni in nedeljski termini ne štejejo v kvoto',
        weekend_free_desc: 'Rezervacije ob vikendih so možne, a ne porabijo kvot skupine. Če to izklopite, se vikend šteje enako kot delovni dnevi.',
        days:            'dni',
    },
    profile: {
        title:        'Profil',
        subtitle:     'Vaš uporabniški profil',
        personal_data: 'Osebni podatki',
        change_password: 'Sprememba gesla',
        current_password: 'Trenutno geslo',
        new_password: 'Novo geslo',
        confirm_password: 'Potrdi novo geslo',
        save_password: 'Spremeni geslo',
        primary_group: 'Primarna skupina',
        logout:       'Odjava',
        my_profile:   'Moj profil',
    },
    time: {
        just_now: 'pravkar',
        min_ago:  'pred {n} min',
        hour_ago: 'pred {n} h',
        yesterday: 'včeraj',
        days_ago: 'pred {n} dnevi',
    },
} as const
